/*
// start the sound loading like this.
// this loads the "main" group by default.
SoundService.load(soundManifest)

// specify a different group:
SoundService.load(soundManifest, 'intro')

// get a sound
let path = require('@/assets/audio/pressandhold_in_96k.mp3')
let bloop = SoundService.get(path)

// play a sound
bloop.play()
*/

export default [
  // main group
  {
    id: 'main',
    urls: [
    ]
  }
]
